import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#3699FF",
    },
    secondary: {
      main: "#E1F0FF",
    },
  },
});

export default theme;
